import { InjectionToken, ValueProvider } from '@angular/core';

export interface Brand {
  appName: string;
  tel: string;
  address: string;
  email: string;
  legalNoticesLink: string;
  cguLink: string;
  connectionHelperLink: string;
}

export const BRAND = new InjectionToken<Brand>('brand');

export const getBrandProvider = (value: Brand): ValueProvider => ({
  provide: BRAND,
  useValue: value,
});
